var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartIcon = function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 18,
    height: 18,
    viewBox: "0 0 21 20",
    fill: "none",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1H3.5L3.9 3L1.5 1ZM5.5 11H15.5L19.5 3H3.9L5.5 11ZM5.5 11L3.9 3L5.5 11ZM5.5 11L3.207 13.293C2.577 13.923 3.023 15 3.914 15H15.5L5.5 11ZM15.5 15C14.9696 15 14.4609 15.2107 14.0858 15.5858C13.7107 15.9609 13.5 16.4696 13.5 17C13.5 17.5304 13.7107 18.0391 14.0858 18.4142C14.4609 18.7893 14.9696 19 15.5 19C16.0304 19 16.5391 18.7893 16.9142 18.4142C17.2893 18.0391 17.5 17.5304 17.5 17C17.5 16.4696 17.2893 15.9609 16.9142 15.5858C16.5391 15.2107 16.0304 15 15.5 15ZM7.5 17C7.5 17.5304 7.28929 18.0391 6.91421 18.4142C6.53914 18.7893 6.03043 19 5.5 19C4.96957 19 4.46086 18.7893 4.08579 18.4142C3.71071 18.0391 3.5 17.5304 3.5 17C3.5 16.4696 3.71071 15.9609 4.08579 15.5858C4.46086 15.2107 4.96957 15 5.5 15C6.03043 15 6.53914 15.2107 6.91421 15.5858C7.28929 15.9609 7.5 16.4696 7.5 17V17Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })));
};
export default SvgCartIcon;